// Third Party Imports
import { AfterViewInit, Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appPopulateDate]'
})
export class PopulateDateDirective implements AfterViewInit {
  private readonly el: HTMLInputElement;
  private input: HTMLInputElement;

  constructor(private readonly elementRef: ElementRef) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('keypress', ['$event'])
  onKeyPress($event: any) {
    const key = $event.key;
    const isSlash = key === '/' || key === 'Divide';

    if (this.el && this.el.value &&
          this.el.selectionStart === this.el.selectionEnd &&
          this.el.value.match('^\\d{2}(/\\d{2})?$') &&
          !isSlash) {
      this.el.value = `${this.el.value}/`;
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown($event: any) {
    const key = $event.key;
    const keyCode = $event.keyCode;
    const isBackspace = keyCode === 8;
    const isDelete = keyCode === 46;
    const isDigit = key.match('[\\d]');
    const isSlash = key === '/' || key === 'Divide';

    if (!this.input || !this.input.value ||
          !isBackspace && !isDelete && !isDigit && !isSlash) {
      return;
    }

    const value = this.input.value;
    let selectionStart = this.input.selectionStart;
    let selectionEnd = this.input.selectionEnd;

    if (isBackspace && selectionStart && selectionEnd) {
      --selectionStart;
      --selectionEnd;
    }
    else if (isDelete) {
      //
    }
    else if (isDigit) {
      ++selectionStart;
      ++selectionEnd;
      if (value.match('^\\d{2}(/\\d{2})?$')) {
        ++selectionStart;
        ++selectionEnd;
      }
    }
    else if (isSlash) {
      ++selectionStart;
      ++selectionEnd;
    }

    setTimeout(() => {
      // changes cause format mm/dd/yyyy only
      if (!this.input.value.match('^\\d{2}/\\d{2}/\\d{4}$')) {
        return;
      }

      // delete odd zero sign
      if (isBackspace || isDelete) {
        this.input.value = value.slice(0, selectionStart) + value.slice(selectionEnd + 1, value.length);
      }
      else if (isDigit || isSlash) {
        const keyValue = isSlash ? '/' : key;
        this.input.value = value.slice(0, selectionStart - 1) + keyValue + value.slice(selectionEnd - 1, value.length);
      }

      // set position
      this.input.setSelectionRange(selectionStart, selectionStart);
    });
  }

  ngAfterViewInit() {
    this.input = this.el.getElementsByTagName('input')[0];
  }
}
